import Cookies from 'js-cookie'
let html = document.getElementsByTagName('html')[0];

export default () => ({
	current_page: document.querySelectorAll('[data-barba-namespace]')[0].dataset.barbaNamespace,
	ack: {
		hidden: true,
		hiding: false
	},
	hideAck() {
		this.ack.hiding = true
		// Uncomment below to enable cookie and expire after 1 day
		Cookies.set('seen_acknowledgement', 'true', { expires: 1 })
		setTimeout(() => {
			html.classList.remove('no-scroll')
			this.ack.hidden = true
			this.ack.hiding = false
		}, 1000)
	},
	init() {
		if (!Cookies.get('seen_acknowledgement') && this.current_page === 'home') {
			this.ack.hidden = false
			html.classList.add('no-scroll')
		}
	}
})
